module.exports = __webpack_public_path__ + "img/banner-bg1.9dc95a54.jpeg";